import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import React from 'react';
import { H6 } from '@finect/tabular-core/Headings';
import { X } from '@finect/tabular-icons/x';
import { Tooltip } from '../../Tooltip';
import { Icon } from '../../Icon';
import { DistributorsFiltersContent, DistributorsContent, Distributor, IconContent, QtyTip } from './partials';
var TooltipFilter = function TooltipFilter(_ref) {
  var item = _ref.item;
  return React.createElement("span", null, item.label, ' ', React.createElement(QtyTip, null, "(", item.qty, " producto", item.qty !== 1 ? 's' : '', ")"));
};
export var ColumnDistributorFilter = function ColumnDistributorFilter(_ref2) {
  var filter = _ref2.filter,
    onChange = _ref2.onChange,
    activeFilter = _ref2.activeFilter,
    onRestore = _ref2.onRestore;
  var label = filter.label,
    id = filter.id,
    items = filter.items,
    column = filter.column;
  return React.createElement(DistributorsFiltersContent, null, React.createElement("div", null, React.createElement(H6, null, label)), React.createElement(DistributorsContent, null, items.map(function (item, index) {
    return React.createElement(Distributor, {
      key: index
    }, React.createElement(IconContent, {
      onClick: function onClick() {
        return onChange(id, [item], column);
      },
      filterActive: Boolean(activeFilter),
      isActive: activeFilter && activeFilter.items.includes(item.id)
    }, React.createElement(Tooltip, {
      key: index,
      tip: React.createElement(TooltipFilter, {
        item: item
      }),
      position: "top",
      from: "left"
    }, React.createElement(Icon, {
      size: 0,
      type: 'company',
      alt: item.label,
      image: item.image,
      margin: "0 8px 0 0"
    }))));
  }), activeFilter ? React.createElement("span", {
    onClick: function onClick() {
      return onRestore(id);
    }
  }, React.createElement(X, {
    size: "14"
  })) : null));
};